<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <b-field label="title" style="width: 100%">
                    <b-input v-model="datReturnToEmit.title"   ></b-input>
                </b-field>

            </header>
            <section class="modal-card-body">
                <!-- Content ... -->


                <b-field class="file">
                    <b-upload v-model="datReturnToEmit.file" @input="selectFileAndUp">
                        <a class="button is-primary">
                            <b-icon icon="upload"></b-icon>
                            <span>Click to upload</span>
                        </a>
                    </b-upload>
                    <span class="file-name" v-if="datReturnToEmit.file">
                            {{ datReturnToEmit.file.name }}
                    </span>
                </b-field>

                <b-field label="" >
                    <figure class="image is-128x128" v-if="datReturnToEmit.urlTempUploaded.length">
                        <img  :src="datReturnToEmit.urlTempUploaded" alt="Image" v-if="datReturnToEmit.urlTempUploaded.length>0">
                    </figure>
                </b-field>


            </section>
            <footer class="modal-card-foot">
                <b-button type="is-danger"  @click="closeBtn" >Close</b-button>
                <b-button type="is-success"  @click="Save" >OK</b-button>
            </footer>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios";
    import { getBaseURLforBackEnd  , getConfigAxiosFormData ,genUUID  }  from '@/utils.js'
    import {mapState} from "vuex";

    export default {
        name: "UploadFiles",
        props:{
            idlab : String,
            plus : Boolean
        },
        computed:{
            ...mapState({
                clientIP : state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            })
        },
        methods:{
            async selectFileAndUp(){
                const formData = new FormData()
                const vm = this
                formData.append('file',this.datReturnToEmit.file)
                formData.append('dat','{ "mode": 1}')
                try{
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`   
                    await axios.post(`${getBaseURLforBackEnd()}/api/upload_avartar`,formData,getConfigAxiosFormData())
                        .then((res)=>{
                            vm.datReturnToEmit.urlTempUploaded = res.data.temp_url
                            vm.datReturnToEmit.fileNameUploaded = res.data.file_name
                        })

                    // this.file = ""
                    this.error = false
                }catch (e) {


                    vm.$buefy.dialog.alert({
                        title: 'Error',
                        message: `ERROR ${e.response.data.msg}`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })


                    vm.$buefy.toast.open({
                        duration: 5000,
                        message: `ERROR ${e.response.data.msg}`,
                        position: 'is-bottom',
                        type: 'is-danger'
                    })

                    vm.message = e.response.data.msg
                    vm.error = true

                    vm.datReturnToEmit.file = null
                    vm.datReturnToEmit.urlTempUploaded = ""
                    vm.datReturnToEmit.fileNameUploaded = ""


                }


            },

            Save(){
                this.datReturnToEmit.id = genUUID(4)
                this.$emit('closeWithData', this.datReturnToEmit)
                // if(!this.plus) {
                //     this.datReturnToEmit.id = genUUID(4)
                //     this.$emit('closeWithData', this.datReturnToEmit)
                // }else{
                //         // console.log(this.datReturnToEmit.title)
                //         // console.log(this.datReturnToEmit.fileNameUploaded )
                //          const datTo = {
                //                          "idlab": this.idlab,
                //                          "path":  this.datReturnToEmit.fileNameUploaded ,
                //                          "ip":    this.clientIP ,
                //                          "title_img" : this.datReturnToEmit.title,
                //                          "idtime" :  genUUID(10)
                //                        }
                //          const vm = this
                //          axios.post(`${getBaseURLforBackEnd()}/api/newinsertimageplus `,datTo,getConfigAxios())
                //          .then(()=>{
                //              vm.$emit(  "closeWithData" )
                //          })
                //          .catch(err=>{
                //              vm.$buefy.dialog.alert({
                //                  title: 'Error',
                //                  message: `${err.message}` ,
                //                  type: 'is-danger',
                //                  hasIcon: true,
                //                  icon: 'times-circle',
                //                  iconPack: 'fa',
                //                  ariaRole: 'alertdialog',
                //                  ariaModal: true
                //              })
                //              vm.$emit(  "closeWithData" )
                //          })
                // }
            },
            closeBtn(){
                this.$emit('close')
            },

        },


        data(){
            return {
                datReturnToEmit : {
                    id: "",
                    file : null,
                    urlTempUploaded: "",
                    title : "",
                    fileNameUploaded : ""
                }
            }
        }
    }
</script>

<style scoped>

</style>